import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import { memo } from "react";
export const DiscussionSkeleton = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "pt-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-3 mr-7 flex items-center lg:mr-11",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        height: 24,
                        style: {
                            marginRight: 12
                        },
                        variant: "round",
                        width: 24
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        height: 10,
                        width: 60
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mr-7 pb-5 pt-2 lg:mr-11",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        height: 10,
                        style: {
                            marginBottom: 8,
                            marginLeft: 36
                        },
                        width: "calc(90% - 36px)"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        height: 10,
                        style: {
                            marginBottom: 8,
                            marginLeft: 36
                        },
                        width: "calc(100% - 36px)"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        height: 10,
                        style: {
                            marginLeft: 36
                        },
                        width: "calc(70% - 36px)"
                    })
                ]
            })
        ]
    });
});
DiscussionSkeleton.displayName = "DiscussionSkeleton";
